export default {
  // list
  'container_lading_order.column.orderId': '托单ID',
  'container_lading_order.column.ladingNo': '提单号',
  'container_lading_order.column.supplierId': '供应商',
  'container_lading_order.column.supplierName': '供应商',
  'container_lading_order.column.transportTime': '承运时间',
  'container_lading_order.column.bookingStatus': '订舱状态',
  'container_lading_order.column.cutoffTime': '截单时间',
  'container_lading_order.column.customsClearanceStatus': '报关状态',
  'container_lading_order.column.customsCutoffTime': '截关时间',
  'container_lading_order.column.customsRequired': '是否需要报关',
  'container_lading_order.column.createBy': '创建人',
  'container_lading_order.column.updateBy': '更新人',
  'container_lading_order.column.createTime': '创建时间',
  'container_lading_order.column.updateTime': '更新时间',
  'container_lading_order.column.dataSource': '数据来源',
  'container_lading_order.column.remark': '备注',
  'container_lading_order.column.status': '状态',
  // edit
  'container_lading_order.edit.title': '编辑集装箱提单',
  'container_lading_order.add.title': '新增集装箱提单',
  'container_lading_order.edit.success': '编辑成功',
  'container_lading_order.add.success': '新增成功',
  'container_lading_order.form.orderId.required': '托单ID不能为空',
  'container_lading_order.form.supplierId.required': '供应商不能为空',
  'container_lading_order.form.supplierName.required': '供应商不能为空',
  'container_lading_order.form.transportTime.required': '承运时间不能为空',
  'container_lading_order.form.customsRequired.required': '是否需要报关不能为空',
  'container_lading_order.form.orderId': '托单ID',
  'container_lading_order.form.orderId.placeholder': '请输入托单ID',
  'container_lading_order.form.supplierId': '供应商',
  'container_lading_order.form.supplierId.placeholder': '请输入供应商',
  'container_lading_order.form.supplierName': '供应商',
  'container_lading_order.form.supplierName.placeholder': '请输入供应商',
  'container_lading_order.form.transportTime': '承运时间',
  'container_lading_order.form.transportTime.placeholder': '请输入承运时间',
  'container_lading_order.form.bookingStatus': '订舱状态',
  'container_lading_order.form.bookingStatus.placeholder': '请输入订舱状态',
  'container_lading_order.form.cutoffTime': '截单时间',
  'container_lading_order.form.cutoffTime.placeholder': '请输入截单时间',
  'container_lading_order.form.customsClearanceStatus': '报关状态',
  'container_lading_order.form.customsClearanceStatus.placeholder': '请输入报关状态',
  'container_lading_order.form.customsCutoffTime': '截关时间',
  'container_lading_order.form.customsCutoffTime.placeholder': '请输入截关时间',
  'container_lading_order.form.customsRequired': '是否需要报关',
  'container_lading_order.form.customsRequired.placeholder': '请输入是否需要报关',
}
